import type { SchemaBuilderFieldType } from "./schema-builder-field-type";
import type {
  GetSchemaBuilderGroupOptionProps,
  SchemaBuilderFieldOptionItem,
  SchemaBuilderGroupOptionItem,
} from "./schema-builder.type";
import type { SchemaField } from "@/entities/schema";

import { createRandomId } from "@/utilities/id";

import { getSchemaBuilderFieldType } from "./schema-builder-field-type";

/**
 * Only use this helper in `schema-builder` context
 */
export const isNewSchemaField = (schema: SchemaField): boolean => {
  // `label` is required and should always be filled
  // When creating a new field, when create tmp data with empty label
  return !schema.label;
};

export const generateFieldUniqueModel = (
  field: SchemaField | SchemaBuilderFieldType
) => {
  const fieldType: SchemaBuilderFieldType =
    typeof field === "string" ? field : getSchemaBuilderFieldType(field);

  const prefix = fieldType === "text" || fieldType === "number" ? "input" : "";

  return `${prefix}${fieldType.toLowerCase()}_${createRandomId()}`;
};

export const generateGroupUniqueLegend = (title: string) => {
  return `${title}_${createRandomId()}`;
};

export const getSchemaBuilderGroupOption = ({
  schemaGroup,
  excludedField,
  excludedType,
}: GetSchemaBuilderGroupOptionProps): SchemaBuilderGroupOptionItem => {
  return {
    label: schemaGroup.legend,
    options: (schemaGroup.fields ?? [])
      .filter((field) => {
        if (excludedField && field.model === excludedField.model) return false;
        if (excludedType && field.type === excludedType) return false;
        return true;
      })
      .map(getSchemaBuilderFieldOption),
  };
};

export const getSchemaBuilderFieldOption = (
  schemaField: SchemaField
): SchemaBuilderFieldOptionItem => {
  return {
    label: `${schemaField.label} - ${schemaField.model}`,
    value: schemaField.model,
    type: getSchemaBuilderFieldType(schemaField),
  };
};
